import React, {useEffect, useState} from 'react';

import {
    Button, Card, CardBody, CardReadMore, CardText, CardTitle,
    Col, Container, Dropdown,
    DropdownMenu,
    DropdownToggle, FormGroup,
    Icon,
    Input, Label,
    LinkList,
    LinkListItem, RegisterOptions,
    Row,
    Select,
    Toggle
} from "design-react-kit";
import {properties} from "../../../config/properties";
import {useNavigate} from "react-router-dom";
const styles = {
    formContainer: {
        padding: '2rem',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        border: '1px solid #ddd'
    },
    formTitle: {
        marginBottom: '1.5rem',
        color: '#333',

        paddingBottom: '0.5rem'
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem' // Spazio tra i pulsanti
    }
};
const RicercaListaSpecimen = () => {


    const [isOpen, setIsOpen] = useState(false);
    const [camere, setCamere] = useState([]);
    const [cciaa, setCciaa] = useState('');
    const [nome, setNome] = useState('');
    const [cognome, setCognome] = useState('');
    const [resetCount, setResetCount] = useState(0);



    const toggle = () => setIsOpen(!isOpen);

    const navigate = useNavigate();


    useEffect(() => {
        async function fetchData() {
            const data = await getCciaaList();
            setCamere(data);
        }
        fetchData();
    }, []);

    const handleConferma = (e) => {
        e.preventDefault();

        const datiRicerca = {

            offset : 0,
            limit : 10,
            dati : {
                nome,
                cognome,
                cciaa
            }
        };

        navigate('/private/listaSpecimen', { state: { ricerca: datiRicerca } });
    };

    return (

        <Container className="bg-white py-5 py-lg-6 ">

            <h2 className={"mb-5"}>Lista Specimen</h2>

            <div className="bg-white py-5 py-lg-6 ">
                <Row>
                    <Col md={5}>
                        <div className="guidance-box lead">
                            <p>
                                È possibile cercare e, se necessario, stampare l’elenco delle persone registrate nella
                                piattaforma per una specifica Camera di Commercio aderente al servizio Specimen.
                            </p>

                        </div>
                    </Col>

                    <Col md={7} lg={6}>
                        <form onSubmit={handleConferma}>

                            <div style={styles.formContainer}>
                                <h3 style={styles.formTitle} className={"pb-5"}>
                                    Filtro di ricerca
                                </h3>

                                <Row className="mb-5">
                                    <Col>
                                        <Select
                                            key={resetCount}
                                            id="cciaa"
                                            label="CCIAA"
                                            value={cciaa}
                                            //defaultValue="*"
                                            onChange={(e) => setCciaa(e)}
                                            required={true}
                                        >
                                            <option value="">Seleziona</option>
                                            {camere.map((item, index) => (
                                                <option key={index} value={item.nomeProvincia}>
                                                    {item.nomeProvincia}
                                                </option>
                                            ))}

                                        </Select>
                                    </Col>
                                </Row>


                                <Row className="mb-5 d-flex justify-content-end">
                                    <Col sm="auto">
                                        <Button
                                            className={"btn btn-outline-warning"}
                                            outline
                                            onClick={() => {
                                                setNome('');
                                                setCognome('');
                                                setCciaa('*');
                                                setResetCount(prev => prev + 1);
                                            }}
                                        >
                                            Cancella
                                        </Button>
                                    </Col>
                                    <Col sm="auto">
                                        <Button
                                            className={"btn btn-outline-primary"}
                                            type="submit"
                                            onSubmit={handleConferma}
                                        >
                                            Conferma
                                        </Button>
                                    </Col>
                                </Row>

                            </div>

                        </form>

                    </Col>

                </Row>

            </div>

        </Container>

    );
};

export default RicercaListaSpecimen;

async function getCciaaList() {
    try {
        //const res = await fetch("http://localhost:8080/fspeWeb/std/service/list/cciaa");
        const res = await fetch(properties.fullBaseUrl + properties.baseAppUrl + "/std/service/list/cciaa");
        if (!res.ok) throw new Error("Errore HTTP");
        const json = await res.json();
        return json;  // qui ritorni direttamente l'array ricevuto
    } catch (e) {
        console.error("Errore nel caricamento delle CCIAA:", e);
        return [];
    }
}
